import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "space-y-4 sm:space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "mt-6 flex flex-col justify-center items-center py-12"
}
const _hoisted_3 = {
  key: 1,
  class: "mt-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6"
}
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-red-700 dark:text-red-300 font-medium" }
const _hoisted_6 = {
  key: 2,
  class: "space-y-4 sm:space-y-6"
}
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between" }
const _hoisted_10 = { class: "relative flex-1 max-w-md" }
const _hoisted_11 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }
const _hoisted_12 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_13 = {
  key: 0,
  class: "card"
}
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "flex items-center gap-2 text-sm text-gray-900 dark:text-blue-300" }
const _hoisted_16 = { class: "inline-flex items-center px-1 py-0.5 rounded text-xs font-medium bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 flex-shrink-0 mr-1 cursor-help" }
const _hoisted_17 = { class: "space-y-1" }
const _hoisted_18 = { class: "flex items-center gap-1 min-w-0" }
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "font-medium break-words flex-1 min-w-0" }
const _hoisted_21 = { class: "text-sm text-gray-500 dark:text-gray-400 line-clamp-2" }
const _hoisted_22 = {
  key: 0,
  class: "text-xs text-blue-600 dark:text-blue-400 mt-1"
}
const _hoisted_23 = { class: "max-w-full" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "flex justify-center" }
const _hoisted_26 = { class: "flex justify-center space-x-2 sm:space-x-3" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "flex justify-end space-x-3" }
const _hoisted_31 = ["onClick", "title"]
const _hoisted_32 = { class: "hidden sm:inline" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "flex flex-col" }
const _hoisted_36 = { class: "mb-1 w-full min-w-0 flex justify-end" }
const _hoisted_37 = { class: "text-base font-semibold text-gray-900 dark:text-white break-words block line-clamp-2 text-right max-w-[85%]" }
const _hoisted_38 = { class: "w-full mb-1 flex justify-end" }
const _hoisted_39 = { class: "text-sm text-gray-500 dark:text-gray-400 line-clamp-2 text-right max-w-[75%] min-w-0" }
const _hoisted_40 = {
  key: 0,
  class: "w-full flex justify-end"
}
const _hoisted_41 = { class: "flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400" }
const _hoisted_42 = { class: "inline-flex items-center px-1 py-0.5 rounded text-xs font-medium bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 flex-shrink-0" }
const _hoisted_43 = { class: "text-xs truncate max-w-[65%] min-w-0 text-right" }
const _hoisted_44 = { class: "max-w-[60%] text-right min-w-0" }
const _hoisted_45 = ["onClick"]

import { ref, computed, onMounted } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { useUser } from '@/composables/auth/useUser'
import { useToastService } from '@/services/toast'
import CreateModule from '@/components/modals/CreateModule.vue'
import CalibrateModules from '@/components/modals/CalibrateModules.vue'
import DataTable from '@/components/common/DataTable.vue'
import EditModule from '@/components/modals/EditModule.vue'
import ViewModule from '@/components/modals/ViewModule.vue'
import ModulesService, { type Module } from '@/services/modules'
import DeleteModule from '@/components/modals/DeleteModule.vue'
import BaseTooltip from '@/components/common/BaseTooltip.vue'
import {
  AlertCircle,
  Plus,
  Edit,
  Trash2,
  Lock,
  LockOpen,
  RefreshCw,
  Calendar,
  Search,
  X
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'ModuleView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Empathy Health Services, Inc.')
useTitle(`Modules - ${appTitle.value}`)

// Get user information
const { userType } = useUser()

// Toast service for notifications
const toast = useToastService()

// Reactive state
const loading = ref(false)
const error = ref<string | null>(null)
const searchQuery = ref('')
const modules = ref<Module[]>([])
const showAddModal = ref(false)
const showSyncModal = ref(false)
const showViewModal = ref(false)
const selectedModule = ref<Module | null>(null)
const showDeleteModal = ref(false)
const moduleToDelete = ref<Module | null>(null)

// Pagination state
const currentPage = ref(1)
const itemsPerPage = ref(10)

// Computed properties
const filteredModules = computed(() => {
  if (!searchQuery.value) return modules.value

  return modules.value.filter(module => {
    const name = module.name || ''
    const description = module.description || ''
    const fileName = getFileName(module.material_filepath) || ''
    const formattedName = formatModuleName(module) // Include formatted name (MMYY-HHA-Title)
    return (
      name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
      description.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
      fileName.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
      formattedName.toLowerCase().includes(searchQuery.value.toLowerCase())
    )
  })
})

// Pre-sorted data for DataTable that maintains our custom sorting logic
const sortedModulesForDataTable = computed(() => {
  const sorted = [...filteredModules.value] // Use filtered modules instead of all modules

  // Sort modules by their assigned order: time settings first, then by module_id
  sorted.sort((a, b) => {
    // Modules with time settings come first, ordered by start_date
    if (a.time_setting && b.time_setting) {
      const aStartDate = new Date(a.time_setting.start_date).getTime()
      const bStartDate = new Date(b.time_setting.start_date).getTime()

      if (aStartDate !== bStartDate) {
        return aStartDate - bStartDate // Always ascending by start date
      } else {
        // If start dates are the same, fall back to module_id for consistent ordering
        return a.module_id - b.module_id
      }
    }

    // Handle modules with time settings vs without
    if (a.time_setting && !b.time_setting) {
      return -1 // Modules with time settings come first
    }
    if (!a.time_setting && b.time_setting) {
      return 1 // Modules without time settings come last
    }

    // For modules without time settings, order by module_id
    return a.module_id - b.module_id
  })

  return sorted
})

// Check if any modules have time settings to show indicator
const hasAnyTimeSettings = computed(() => modules.value.some(module => module.time_setting))

// DataTable Configuration
const tableColumns = [
  {
    key: 'module',
    label: 'Module',
    sortable: false
  },
  {
    key: 'file',
    label: 'File',
    sortable: false
  },
  {
    key: 'status',
    label: 'Status',
    sortable: false,
    align: 'center' as const
  }
]

const mobileColumns = [
  {
    key: 'module',
    label: 'Module',
    primary: true
  },
  {
    key: 'file',
    label: 'File',
    secondary: true
  }
]

// DataTable event handlers
const handlePageChange = (page: number) => {
  currentPage.value = page
}

const handleItemsPerPageChange = (newItemsPerPage: number) => {
  itemsPerPage.value = newItemsPerPage
  currentPage.value = 1 // Reset to first page
}

// Helper functions
const formatDateRange = (startDate: string, endDate: string) => {
  const start = new Date(startDate).toLocaleDateString()
  const end = new Date(endDate).toLocaleDateString()
  return `${start} - ${end}`
}

const formatModuleName = (module: Module): string => {
  // Remove "Module X -" pattern from the name (where X is any number)
  let cleanedName = module.name.replace(/^Module\s+\d+\s*-\s*/i, '').trim()
  
  if (!module.time_setting || !module.time_setting.start_date) {
    return cleanedName
  }
  
  const startDate = new Date(module.time_setting.start_date)
  const month = String(startDate.getMonth() + 1).padStart(2, '0') // getMonth() returns 0-11
  const year = String(startDate.getFullYear()).slice(-2) // Get last 2 digits of year
  
  return `${month}${year}-HHA-${cleanedName}`
}

// Methods
const fetchModules = async () => {
  loading.value = true
  error.value = null

  try {
    const modulesList = await ModulesService.getModules()
    // console.log('Modules fetched successfully:', modulesList)
    modules.value = modulesList
  } catch (err: any) {
    console.error('Failed to fetch modules:', err)
    error.value = 'Failed to fetch modules. Please try again.'
    modules.value = [] // Remove dummy data
  } finally {
    loading.value = false
  }
}

const onModuleCreated = () => {
  // Refresh the modules list when a new module is created
  fetchModules()
  // Close the modal
  showAddModal.value = false
}

const onSyncSuccess = (message: string) => {
  // Show success toast notification
  toast.success('Sync Successful', message)
  // Refresh the modules list to show updated time settings
  fetchModules()
  // Close the modal
  showSyncModal.value = false
}

const getFileName = (filePath: string | null | undefined): string => {
  if (!filePath) return '(No file uploaded)'
  const pathParts = filePath.split('/')
  return pathParts[pathParts.length - 1] || '(No file uploaded)'
}

const hasFile = (filePath: string | null | undefined): boolean => {
  return !!(filePath && filePath.trim())
}

const getStatusFormatted = (status: string | number | null | undefined): string => {
  if (status === null || status === undefined) return 'Inactive'
  const statusNum = Number(status)
  if (statusNum === 1) return 'Active'
  return 'Inactive'
}

// Search and filter methods
const handleSearch = (query: string) => {
  // Update our search query which will trigger the filteredModules computed property
  searchQuery.value = query || ''
  currentPage.value = 1 // Reset to first page when searching
}

const clearSearch = () => {
  searchQuery.value = ''
  currentPage.value = 1
}

// Action methods
const viewModule = (module: Module) => {
  selectedModule.value = module
  showViewModal.value = true
}

const loadingToggle = ref(false)
const toggleInProgress = ref<number | null>(null)

// Updated toggle function
const toggleModuleStatus = async (module: Module) => {
  try {
    toggleInProgress.value = module.module_id
    loadingToggle.value = true

    const newStatus = module.status === 1 ? 0 : 1
    const action = newStatus === 1 ? 'Activated' : 'Deactivated'

    const response = await ModulesService.updateModuleStatus(module.module_id, newStatus as 0 | 1)
    
    if (response.success) {
      // Update local state only if API call succeeds
      const moduleIndex = modules.value.findIndex(m => m.module_id === module.module_id)
      if (moduleIndex !== -1) {
        modules.value[moduleIndex].status = newStatus
      }
      toast.success(`Module "${module.name}" has been ${action}.`)
    } else {
      toast.error(response.message || 'Failed to update module status.')
    }
  } catch (error: any) {
    console.error('Error toggling module status:', error)
    const errorMessage = error.message || 'Failed to update module status. Please try again.'
    toast.error(errorMessage)
  } finally {
    loadingToggle.value = false
    toggleInProgress.value = null
  }
}

// For Edit Module
const showEditModal = ref(false)

const editModule = (module: Module) => {
  selectedModule.value = module
  showEditModal.value = true
}

const onModuleUpdated = async () => {
  // Store the current module ID before refreshing
  const currentModuleId = selectedModule.value?.module_id
  
  // Refresh the modules list when a module is updated
  await fetchModules()
  
  // Close the edit modal
  showEditModal.value = false
  
  // If ViewModule was open, update selectedModule with fresh data
  if (currentModuleId && showViewModal.value) {
    const updatedModule = modules.value.find(m => m.module_id === currentModuleId)
    if (updatedModule) {
      selectedModule.value = updatedModule
    }
  } else {
    // Reset selected module if ViewModule is not open
    selectedModule.value = null
  }

  // Show success notification
  toast.success('Module has been updated successfully')
}

// Delete Module
const deleteModule = (module: Module) => {
  moduleToDelete.value = module
  showDeleteModal.value = true
}

const onModuleDeleteSuccess = () => {
  fetchModules()
  showDeleteModal.value = false
  moduleToDelete.value = null
}

const onDeleteModalClose = () => {
  showDeleteModal.value = false
  moduleToDelete.value = null
}

// Lifecycle
onMounted(() => {
  fetchModules()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "card" }, [
      _createElementVNode("div", { class: "card-body" }, [
        _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-primary-text dark:text-primary-dark-text mb-2" }, " Modules "),
        _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " Manage training modules and learning content ")
      ])
    ], -1)),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-4" }, null, -1),
          _createElementVNode("span", { class: "text-primary-text dark:text-primary-dark-text" }, "Loading modules...", -1)
        ]))]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(AlertCircle), { class: "h-5 w-5 text-red-500 mr-2" }),
              _createElementVNode("span", _hoisted_5, _toDisplayString(error.value), 1)
            ]),
            _createElementVNode("button", {
              onClick: fetchModules,
              class: "mt-2 text-sm text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-200 underline"
            }, " Try again ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(Search), { class: "h-5 w-5 text-gray-400" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                      onInput: _cache[1] || (_cache[1] = ($event: any) => (handleSearch(searchQuery.value))),
                      placeholder: "Search modules...",
                      class: "block w-full pl-10 pr-10 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-primary focus:border-primary transition duration-200 shadow-sm hover:shadow-md focus:shadow-md"
                    }, null, 544), [
                      [_vModelText, searchQuery.value]
                    ]),
                    (searchQuery.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: clearSearch,
                          class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors duration-200",
                          title: "Clear search"
                        }, [
                          _createVNode(_unref(X), { class: "h-4 w-4" })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(userType) === 'Admin')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(BaseTooltip, {
                          text: "Sync module time settings to schedule start and end dates",
                          position: "top"
                        }, {
                          trigger: _withCtx(() => [
                            _createElementVNode("button", {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (showSyncModal.value = true)),
                              class: "btn btn-secondary btn-sm flex items-center gap-2"
                            }, [
                              _createVNode(_unref(RefreshCw), { class: "h-4 w-4" }),
                              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "hidden sm:inline" }, "Sync", -1))
                            ])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("button", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (showAddModal.value = true)),
                          class: "btn btn-primary btn-sm flex items-center gap-2"
                        }, [
                          _createVNode(_unref(Plus), { class: "h-4 w-4" }),
                          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "hidden sm:inline" }, "Add Module", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (hasAnyTimeSettings.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(BaseTooltip, {
                        text: "Green badge: module has synced time settings (scheduled start and end dates)",
                        position: "right"
                      }, {
                        trigger: _withCtx(() => [
                          _createElementVNode("span", _hoisted_16, [
                            _createVNode(_unref(Calendar), { class: "h-5 w-5" })
                          ])
                        ]),
                        _: 1
                      }),
                      _cache[12] || (_cache[12] = _createElementVNode("span", null, " Modules are ordered by their assigned time settings. A green badge indicates a module has been synced and has scheduled start/end dates; modules without time settings appear at the end. ", -1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(DataTable, {
              data: sortedModulesForDataTable.value,
              columns: tableColumns,
              loading: loading.value,
              "mobile-columns": mobileColumns,
              "item-key": "module_id",
              "item-label": "modules",
              "search-placeholder": "Search modules...",
              "show-search": false,
              "show-filters": false,
              "show-search-section": false,
              "show-pagination": true,
              "show-summary": true,
              "items-per-page": itemsPerPage.value,
              "items-per-page-options": [5, 10, 25, 50],
              onPageChange: handlePageChange,
              onItemsPerPageChange: handleItemsPerPageChange
            }, _createSlots({
              "cell-module": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (item.time_setting)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "inline-flex items-center px-1 py-0.5 rounded text-xs font-medium bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 flex-shrink-0 mr-1",
                          title: `Scheduled: ${formatDateRange(item.time_setting.start_date, item.time_setting.end_date)}`
                        }, [
                          _createVNode(_unref(Calendar), { class: "h-3 w-3" })
                        ], 8, _hoisted_19))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(formatModuleName(item)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(item.description || 'No description available'), 1),
                  (item.time_setting)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(formatDateRange(
                item.time_setting.start_date,
                item.time_setting.end_date
              )), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              "cell-file": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(BaseTooltip, {
                    text: "Click to view details",
                    position: "left"
                  }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["cursor-pointer hover:underline transition-colors duration-200 block truncate", hasFile(item.material_filepath) ? 'text-blue-700 dark:text-blue-500 hover:text-blue-900 hover:dark:text-blue-700' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 hover:dark:text-gray-300']),
                        onClick: ($event: any) => (viewModule(item))
                      }, _toDisplayString(getFileName(item.material_filepath)), 11, _hoisted_24)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              "cell-status": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(BaseTooltip, {
                    text: getStatusFormatted(item.status) === 'Active' ? 'This module is currently active and accessible to employees' : 'This module is currently inactive and not accessible to employees',
                    position: "left"
                  }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                  'px-2 inline-flex text-xs leading-5 font-semibold rounded-full cursor-help',
                  getStatusFormatted(item.status) === 'Active'
                    ? 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100'
                    : 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100'
                ])
                      }, _toDisplayString(getStatusFormatted(item.status)), 3)
                    ]),
                    _: 2
                  }, 1032, ["text"])
                ])
              ]),
              "mobile-module": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, _toDisplayString(formatModuleName(item)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("p", _hoisted_39, _toDisplayString(item.description || 'No description available'), 1)
                  ]),
                  (item.time_setting)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", _hoisted_42, [
                            _createVNode(_unref(Calendar), { class: "h-3 w-3" })
                          ]),
                          _createElementVNode("span", _hoisted_43, _toDisplayString(formatDateRange(item.time_setting.start_date, item.time_setting.end_date)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              "mobile-file": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(BaseTooltip, {
                    text: "Click to view details",
                    position: "top"
                  }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["cursor-pointer hover:underline transition-colors duration-200 block break-words line-clamp-2", hasFile(item.material_filepath) ? 'text-blue-700 dark:text-blue-500 hover:text-blue-900 hover:dark:text-blue-700' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 hover:dark:text-gray-300']),
                        onClick: ($event: any) => (viewModule(item))
                      }, _toDisplayString(getFileName(item.material_filepath)), 11, _hoisted_45)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              "empty-actions": _withCtx(() => [
                (_unref(userType) === 'Admin')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (showAddModal.value = true)),
                      class: "btn btn-primary btn-sm flex items-center gap-2 justify-center"
                    }, [
                      _createVNode(_unref(Plus), { class: "h-4 w-4" }),
                      _cache[15] || (_cache[15] = _createTextVNode(" Create Module ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (_unref(userType) === 'Admin')
                ? {
                    name: "row-actions",
                    fn: _withCtx(({ item }) => [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(BaseTooltip, {
                          text: getStatusFormatted(item.status) === 'Active' ? 'Deactivate' : 'Activate',
                          position: "top"
                        }, {
                          trigger: _withCtx(() => [
                            _createElementVNode("button", {
                              class: _normalizeClass([
                  'transition duration-200 transform',
                  getStatusFormatted(item.status) === 'Active'
                    ? 'text-secondary dark:text-secondary-dark dark:hover:text-gray-500 hover:text-gray-900'
                    : 'text-primary dark:text-primary-dark hover:text-gray-900 dark:hover:text-gray-500'
                ]),
                              onClick: ($event: any) => (toggleModuleStatus(item))
                            }, [
                              (getStatusFormatted(item.status) === 'Active')
                                ? (_openBlock(), _createBlock(_unref(LockOpen), {
                                    key: 0,
                                    class: "h-5 w-5"
                                  }))
                                : (_openBlock(), _createBlock(_unref(Lock), {
                                    key: 1,
                                    class: "h-5 w-5"
                                  }))
                            ], 10, _hoisted_27)
                          ]),
                          _: 2
                        }, 1032, ["text"]),
                        _createVNode(BaseTooltip, {
                          text: "Edit module",
                          position: "top"
                        }, {
                          trigger: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "text-blue-500 hover:text-blue-700 transition",
                              onClick: ($event: any) => (editModule(item))
                            }, [
                              _createVNode(_unref(Edit), { class: "h-5 w-5" })
                            ], 8, _hoisted_28)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(BaseTooltip, {
                          text: "Delete module",
                          position: "top"
                        }, {
                          trigger: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "text-red-500 hover:text-red-700 transition",
                              onClick: ($event: any) => (deleteModule(item))
                            }, [
                              _createVNode(_unref(Trash2), { class: "h-5 w-5" })
                            ], 8, _hoisted_29)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    key: "0"
                  }
                : undefined,
              (_unref(userType) === 'Admin')
                ? {
                    name: "mobile-actions",
                    fn: _withCtx(({ item }) => [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("button", {
                          class: _normalizeClass([
              'transition duration-200 transform flex items-center gap-1 px-2 py-1 rounded text-sm',
              getStatusFormatted(item.status) === 'Active'
                ? 'text-secondary dark:text-secondary-dark hover:bg-gray-100 dark:hover:bg-gray-700'
                : 'text-primary dark:text-primary-dark hover:bg-gray-100 dark:hover:bg-gray-700'
            ]),
                          onClick: ($event: any) => (toggleModuleStatus(item)),
                          title: 
              getStatusFormatted(item.status) === 'Active'
                ? 'Deactivate Module'
                : 'Activate Module'
            
                        }, [
                          (getStatusFormatted(item.status) === 'Active')
                            ? (_openBlock(), _createBlock(_unref(LockOpen), {
                                key: 0,
                                class: "h-4 w-4"
                              }))
                            : (_openBlock(), _createBlock(_unref(Lock), {
                                key: 1,
                                class: "h-4 w-4"
                              })),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(getStatusFormatted(item.status) === 'Active' ? 'Deactivate' : 'Activate'), 1)
                        ], 10, _hoisted_31),
                        _createElementVNode("button", {
                          class: "text-blue-500 hover:text-blue-700 transition flex items-center gap-1 px-2 py-1 rounded hover:bg-blue-50 dark:hover:bg-blue-900/20",
                          onClick: ($event: any) => (editModule(item)),
                          title: "Edit Module"
                        }, [
                          _createVNode(_unref(Edit), { class: "h-4 w-4" }),
                          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "hidden sm:inline" }, "Edit", -1))
                        ], 8, _hoisted_33),
                        _createElementVNode("button", {
                          class: "text-red-500 hover:text-red-700 transition flex items-center gap-1 px-2 py-1 rounded hover:bg-red-50 dark:hover:bg-red-900/20",
                          onClick: ($event: any) => (deleteModule(item)),
                          title: "Delete Module"
                        }, [
                          _createVNode(_unref(Trash2), { class: "h-4 w-4" }),
                          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "hidden sm:inline" }, "Delete", -1))
                        ], 8, _hoisted_34)
                      ])
                    ]),
                    key: "1"
                  }
                : undefined
            ]), 1032, ["data", "loading", "items-per-page"])
          ])),
    _createVNode(CreateModule, {
      "is-visible": showAddModal.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (showAddModal.value = false)),
      onSuccess: onModuleCreated
    }, null, 8, ["is-visible"]),
    _createVNode(EditModule, {
      "is-visible": showEditModal.value,
      module: selectedModule.value || undefined,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (showEditModal.value = false)),
      onSuccess: onModuleUpdated
    }, null, 8, ["is-visible", "module"]),
    _createVNode(CalibrateModules, {
      "is-visible": showSyncModal.value,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (showSyncModal.value = false)),
      onSuccess: onSyncSuccess
    }, null, 8, ["is-visible"]),
    _createVNode(ViewModule, {
      "is-visible": showViewModal.value,
      module: selectedModule.value,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (showViewModal.value = false))
    }, null, 8, ["is-visible", "module"]),
    _createVNode(DeleteModule, {
      "is-visible": showDeleteModal.value,
      module: moduleToDelete.value,
      onClose: onDeleteModalClose,
      onSuccess: onModuleDeleteSuccess
    }, null, 8, ["is-visible", "module"])
  ]))
}
}

})